import api from "./apis";
import { ERROR_MESSAGE, LOADED, LOADING, SUCCESS_MESSAGE, VALIDATION_ERROR } from "./types";
import history from "../history";


export const getClients = (p,e,a,au,b) => async (dispatch) => {
 
  dispatch({ type: LOADING });
  try{
    let response = null;
      response = await api(localStorage.getItem("token")).get(`/client-management/client?p=${p?p:1}&email=${e?e:""}&brand=${b?b:""}&authenticated=${au?au:""}&active=${a?a:""}`);
      // console.log(response)  
    if(response.status === 200 ) {
      dispatch({ type: LOADED });
      return response.data;
      
    }
  }
  catch( err ){
      /* =============Start========== */
        if(err?.response?.status === 422){
          err.response.data.errors.map(item => {
              dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
          })
        }
        if(err?.response?.status === 401 || err?.response?.status === 403 ){
            dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
            localStorage.clear();
            history.push('/login')
        }
        dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/opps') });
        dispatch({type: LOADED});
      /* ===========End============*/
    }
}

export const getClientDetails = (id) => async (dispatch) => {
  dispatch({ type: LOADING });
  try{
    
    const response = await api(localStorage.getItem("token")).get(`/client-management/client/detail?client=${id}`);
    if(response.status === 200 ) {
      dispatch({ type: LOADED });
      return response.data.details;
    }
  }
  catch( err ){
      /* =============Start========== */
        if(err?.response?.status === 422){
          err.response.data.errors.map(item => {
              dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
          })
        }
        if(err?.response?.status === 401 || err?.response?.status === 403 ){
            dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
            localStorage.clear();
            history.push('/login')
        }
        dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/opps') });
        dispatch({type: LOADED});
      /* ===========End============*/
    }
}
export const getClientStatic = (user_id) => async (dispatch) => {
  dispatch({ type: LOADING });
  try{
    
    const response = await api(localStorage.getItem("token")).get(`/client-management/client/statistics?client=${user_id}`);

    if(response.status === 200 ) {
      dispatch({ type: LOADED });
      return response.data;
    }
  }
  catch( err ){
      /* =============Start========== */
        if(err?.response?.status === 422){
          err.response.data.errors.map(item => {
              dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
          })
        }
        if(err?.response?.status === 401 || err?.response?.status === 403 ){
            dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
            localStorage.clear();
            history.push('/login')
        }
        dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/opps') });
        dispatch({type: LOADED});
      /* ===========End============*/
    }
}

export const updateClientAuth = (data,remark) => async (dispatch) => {
  dispatch({ type: LOADING });
  try {


    const obj = {
      client: data[0],
      remark: remark.remark,
      authenticated: data[1],
    }
    const response = await api(localStorage.getItem("token")).patch("/client-management/client/auth", {...obj});

    if (response.status === 201) {
      dispatch({
        type: SUCCESS_MESSAGE,
        payload: "Operation successful",
      });
      
      dispatch({ type: LOADED });
      return response.status
    } else {
      dispatch({ type: LOADED });
    }
  } catch (err) {
      /* =============Start========== */
        if(err?.response?.status === 422){
          err.response.data.errors.map(item => {
              dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
          })
        }
        if(err?.response?.status === 401 || err?.response?.status === 403 ){
            dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
            localStorage.clear();
            history.push('/login')
        }
        dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/opps') });
        dispatch({type: LOADED});
      /* ===========End============*/
    }
};

export const updateUnitCost = (data,user_id) => async (dispatch) => {

  dispatch({ type: LOADING });
  
  const obj = {
    client: user_id,
    remark: data.remark,
    unit_cost: data.unit_cost,
  }
  dispatch({type: LOADED});
  try {

    const response = await api(localStorage.getItem("token")).patch("/client-management/client/unit-cost/update", {...obj});

    if (response.status === 201) {
      
      dispatch({type: LOADED});
      dispatch({type: SUCCESS_MESSAGE,payload: "Unit Cost is updated succesfully"});
      
      return response.status;
      }
  } catch (err) {
      /* =============Start========== */
        if(err?.response?.status === 422){
          err.response.data.errors.map(item => {
              dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
          })
        }
        if(err?.response?.status === 401 || err?.response?.status === 403 ){
            dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
            localStorage.clear();
            history.push('/login')
        }
        dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/opps') });
        dispatch({type: LOADED});
      /* ===========End============*/
    }
};

export const updateClientAccount = (data,remark) => async (dispatch) => {
  dispatch({ type: LOADING });

  try {


    const obj = {
      client: data[0],
      remark: remark.remark,
      active: data[1],
      
    }
    const response = await api(localStorage.getItem("token")).patch("/client-management/client/account/auth", {...obj});


    if (response.status === 201) {
      dispatch({
        type: SUCCESS_MESSAGE,
        payload: "Operation successful",
      });
      
      dispatch({ type: LOADED });
      return response.status
    } else {
      dispatch({ type: LOADED });
    }
  } catch (err) {
      /* =============Start========== */
        if(err?.response?.status === 422){
          err.response.data.errors.map(item => {
              dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
          })
        }
        if(err?.response?.status === 401 || err?.response?.status === 403 ){
            dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
            localStorage.clear();
            history.push('/login')
        }
        dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/opps') });
        dispatch({type: LOADED});
      /* ===========End============*/
    }
};


export const getLegalCheckList = (p,e,ds,de) => async (dispatch) => {
  dispatch({ type: LOADING });
  try{
    let response = null;
    if(ds && de){
      response = await api(localStorage.getItem("token")).get(`/client-management/health/check?p=${p?p:1}&e=${e?e:""}&ds=${ds}&de=${de}`);
    }
    else{
      response = await api(localStorage.getItem("token")).get(`/client-management/health/check?p=${p?p:1}&e=${e?e:""}`);
    }
      if(response.status === 200 ) {
      dispatch({ type: LOADED });
      return response.data;
    }
  }
  catch( err ){
      /* =============Start========== */
        if(err?.response?.status === 422){
          err.response.data.errors.map(item => {
              dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
          })
        }
        if(err?.response?.status === 401 || err?.response?.status === 403 ){
            dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
            localStorage.clear();
            history.push('/login')
        }
        dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/opps') });
        dispatch({type: LOADED});
      /* ===========End============*/
    }
}

export const updateClientPassword = ( data,user_id ) => async (dispatch) => {
  dispatch({type: LOADING});
// console.log(data)
// console.log(data)
// console.log(remark)
  const object = {
    client:user_id,
    password:data?.password,
    confirm_password: data?.confirm_password,
    remark:data?.remark,
  };
  dispatch({type: LOADED});

  try {
    const response = await api(localStorage.getItem("token")).patch("client-management/client/pass/update",{ ...object });
    // console.log(response)
    if (response.status === 201) {
      
    dispatch({type: LOADED});
    dispatch({type: SUCCESS_MESSAGE,payload: "Client password is updated successfully"});
    return response.status
    }
  } catch (err) {
    /* =============Start========== */
      if(err?.response?.status === 422){
        err.response.data.errors.map(item => {
            dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
        })
      }
      if(err?.response?.status === 401 || err?.response?.status === 403 ){
          dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
          localStorage.clear();
          history.push('/login')
      }
      dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/notFound') });
      dispatch({type: LOADED});
    /* ===========End============*/}
};
//  updateclient 
export const updateClient = (data,user_id) => async (dispatch) => {
  dispatch({type: LOADING});
  // console.log(data)
  const address = {
    street_address: data.street_address,
    post_code: data.post_code,
    city: data.city,
    
  };
 
  const company_detail = {
    name: data.name,
    mobile_number: data.mobile_number,
    email: data.email,
    address:{
      street_address: data.street_address,
      post_code: data.post_code,
      city: data.city,
      
    },
  };
  const object = {
    client:user_id,
    remark:data.remark,
    first_name: data.first_name,
    last_name: data.last_name,
    mobile_number: data.mobile_number,
    email: data.email,
    brand_name: data.brand_name,
    address,
    client_type: data.client_type,   
    company_detail,
  };
  dispatch({type: LOADED});

  try {
    const response = await api(localStorage.getItem("token")).patch("/client-management/client/profile/update",{ ...object });

    if (response.status === 201) {
      
    dispatch({type: LOADED});
    dispatch({type: SUCCESS_MESSAGE,payload: "Client is updated succesfully"});
    
    return response.status;
    }
  } catch (err) {
    /* =============Start========== */
      if(err?.response?.status === 422){
        err.response.data.errors.map(item => {
            dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
        })
      }
      if(err?.response?.status === 401 || err?.response?.status === 403 ){
          dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
          localStorage.clear();
          history.push('/login')
      }
      dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/notFound') });
      dispatch({type: LOADED});
    /* ===========End============*/}
};

